import { CS } from "../../../../base/utils/styler";

export const tabTitlesStyle: CS = {
    display: 'flex',
    marginBottom: '-4px',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%',
    direction: 'rtl',
    backgroundColor: '#e4f0ff'
}